export const PORTFOLIO_POSITION_VIEW = ["accounts", "securities"] as const;
export type PortfolioPositionView = (typeof PORTFOLIO_POSITION_VIEW)[number];
export const PORTFOLIO_POSITION_VIEW_OBJ = {
  ACCOUNTS: PORTFOLIO_POSITION_VIEW[0],
  SECURITIES: PORTFOLIO_POSITION_VIEW[1],
} as const satisfies Record<string, PortfolioPositionView>;
